import React from 'react';
import { motion } from 'framer-motion';

// v3.9 ENEMY INTRO CARD — replaces the old boss-intro-banner with a proper cinematic overlay.
// Fires for both elites and bosses; each tier gets a distinct entrance animation.
export default function EnemyIntroCard({ tier, name, sprite, affix }) {
  const isBoss = tier === 'boss';
  const isElite = tier === 'elite';
  const accent = isBoss ? '#ff007f' : '#ff6a00';
  const tierLabel = isBoss ? 'BOSS' : 'ELITE';
  const flair = isBoss ? '⚠' : '★';

  return (
    <motion.div
      className={`enemy-intro-overlay ${isBoss ? 'is-boss' : 'is-elite'}`}
      data-testid="enemy-intro-card"
      data-tier={tier}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.18 }}
    >
      {/* Backdrop dim */}
      <div className="enemy-intro-backdrop" />

      {/* Boss: glitch fracture layer. Elite: slash swipe. */}
      {isBoss ? (
        <>
          <div className="enemy-intro-glitch enemy-intro-glitch-r" />
          <div className="enemy-intro-glitch enemy-intro-glitch-g" />
          <div className="enemy-intro-glitch enemy-intro-glitch-b" />
        </>
      ) : (
        <>
          <div className="enemy-intro-slash enemy-intro-slash-1" />
          <div className="enemy-intro-slash enemy-intro-slash-2" />
        </>
      )}

      <motion.div
        className="enemy-intro-card-body"
        initial={{ x: 240, rotate: -8, opacity: 0, scale: 0.85 }}
        animate={{ x: 0, rotate: 0, opacity: 1, scale: 1 }}
        transition={{ type: 'spring', stiffness: 220, damping: 16, delay: 0.06 }}
        style={{ ['--accent']: accent }}
      >
        <motion.div
          className="enemy-intro-tier"
          data-testid="enemy-intro-tier"
          style={{ color: accent, borderColor: accent }}
          animate={{ scale: [1, 1.06, 1] }}
          transition={{ duration: 0.9, repeat: Infinity, ease: 'easeInOut' }}
        >
          {flair} {tierLabel} {flair}
        </motion.div>

        <motion.div
          className="enemy-intro-sprite"
          initial={{ scale: 0.4, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 260, damping: 14, delay: 0.14 }}
          style={{ filter: `drop-shadow(0 0 32px ${accent})` }}
          data-testid="enemy-intro-sprite"
        >
          {sprite}
        </motion.div>

        <motion.div
          className="enemy-intro-name"
          data-testid="enemy-intro-name"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.35, delay: 0.24 }}
          style={{ textShadow: `0 0 22px ${accent}, 4px 4px 0 rgba(0,0,0,0.9)` }}
        >
          {name}
        </motion.div>

        {affix && (
          <motion.div
            className="enemy-intro-affix"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 0.85 }}
            transition={{ duration: 0.35, delay: 0.32 }}
            style={{ color: accent }}
          >
            · {affix.toUpperCase()} ·
          </motion.div>
        )}

        {isBoss && (
          <motion.div
            className="enemy-intro-warning"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.6, 1] }}
            transition={{ duration: 0.9, delay: 0.4 }}
          >
            APPROACHES.
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  );
}
